<template lang="">
    <div>
        <img id='imagen'  class="fondo" :src="require(`@/assets/hmi/main.png`)" alt="Planta">
        <hmi-componente-auto-man :valor="selectorAutoMan" @auto_man="cambioAutoman" position="absolute" heigth="6%" width="15%" top="29%" left="10%"></hmi-componente-auto-man> 
        <hmi-componente-estado-barrera :valor="estadoBarrera" position="absolute" heigth="20%" width="2%" top="15%" left="28%"></hmi-componente-estado-barrera> 
        <hmi-componente-estado-barrera :valor="estadoBarrera" position="absolute" heigth="20%" width="2%" top="15%" left="83%"></hmi-componente-estado-barrera> 

        <hmi-componente-detector-tajadera :valor="detectorTajaderaArribaAbierta" position="absolute" heigth="2%" width="2%" top="30%" left="31%"></hmi-componente-detector-tajadera>     
        <hmi-componente-detector-tajadera :valor="detectorTajaderaArribaCerrada" position="absolute" heigth="2%" width="2%" top="34%" left="31%"></hmi-componente-detector-tajadera>   
        
        <hmi-componente-detector-tajadera :valor="detectorTajaderaAbajoAbierta" position="absolute" heigth="2%" width="2%" top="52%" left="31%"></hmi-componente-detector-tajadera>     
        <hmi-componente-detector-tajadera :valor="detectorTajaderaAbajoCerrada" position="absolute" heigth="2%" width="2%" top="56%" left="31%"></hmi-componente-detector-tajadera> 
        <hmi-componente-selector-programa  :valor="selectorPrograma" position="absolute" heigth="10%" width="10%" top="36%" left="83%"></hmi-componente-selector-programa>
        <!-- Salidas -->
        <hmi-componente-mostrar-valor 
            :valor="temperaturaSalidaResistencias"
            unidad="ºC" 
            position="absolute"
            heigth="5%" width="7%" top="79%" left="9%"
            ></hmi-componente-mostrar-valor> 
            <!-- Estado temperatura resistencias-->
            <hmi-estado
            heigth="3%" width="3%" top="76%" left="6%"
            :valor="estadoTemperaturaResistencias"
            ></hmi-estado>

        <hmi-componente-mostrar-valor 
            :valor="temperaturaTromel"
            unidad="ºC" 
            position="absolute"
            heigth="5%" width="7%" top="40%" left="75%"></hmi-componente-mostrar-valor> 

        <hmi-componente-mostrar-valor 
            :valor="CaudalAire"
            unidad="m3/h" 
            position="absolute"
            heigth="8%" width="10%" top="77%" left="65%"
            ></hmi-componente-mostrar-valor> 

            <!-- Estado de la calidad del aire -->
            <hmi-estado
            heigth="2%" width="2%" top="75%" left="75%"
            :valor="estadoCalidadAire"
            ></hmi-estado>
        
        <!-- Tajadera arriba  -->
            <!-- Pulsador -->
        <hmi-pulsador
            @click="tajaderaArriba"
            icono="mdi-arrow-up-bold"
            position="absolute"
            heigth="4%" width="4%" top="28%" left="37%"
            ></hmi-pulsador>
            <!-- <hmi-pulsador
            @click="tajaderaArriba(false)"
            icono="mdi-arrow-down-bold"
            position="absolute"
            heigth="4%" width="4%" top="33%" left="41%"
            ></hmi-pulsador> -->
            <!-- EV -->
            <hmi-estado 
            :valor="EvTajaderaArriba"
            heigth="4%" width="4%" top="33%" left="37%"
            ></hmi-estado>

          <!-- Tajadera abajo  -->
            <!-- Pulsador -->
        <hmi-pulsador
            @click="tajaderaAbajo"
            icono="mdi-arrow-up-bold"
            position="absolute"
            heigth="4%" width="4%" top="50%" left="37%"
            ></hmi-pulsador>
            <!-- <hmi-pulsador
            @click="tajaderaAbajo(false)"
            icono="mdi-arrow-down-bold"
            position="absolute"
            heigth="4%" width="4%" top="50%" left="41%"
            ></hmi-pulsador> -->
            <!-- EV -->
            <hmi-estado 
            :valor="EvTajaderaAbajo"
            heigth="4%" width="4%" top="55%" left="37%"
            ></hmi-estado>

        <!-- TROMEL  -->
            <!-- marcha-->
            <hmi-estado-buleano
                :valor="marchaVariadorTromel"
                heigth="4%" width="4%" top="41%" left="27%"
                ></hmi-estado-buleano>
                <!-- Estado detector posicionado -->
                <hmi-estado
                    heigth="4%" width="8%" top="55%" left="82%"
                    :valor="estadoDetectorPosicionado"
                ></hmi-estado>
            <!-- Pulsador -->
        <hmi-pulsador
            @click="pulsadorTromel"
            icono="mdi-arrow-up-bold"
            position="absolute"
            heigth="4%" width="4%" top="37%" left="20%"
            ></hmi-pulsador>

            <!-- Estado motor -->
            <hmi-estado
                :valor="estadoMotorTromel"
                heigth="4%" width="4%" top="45%" left="20%"
                ></hmi-estado>

            <!-- <hmi-pulsador
            @click="pulsadorTromel(false)"
            icono="mdi-arrow-down-bold"
            position="absolute"
            heigth="4%" width="4%" top="37%" left="25%"
            ></hmi-pulsador> -->
            <!-- EV -->
        <!-- Resistencias -->
            <!-- resistencia 1 -->
        <hmi-pulsador
            @click="pulsadorResistencia1"
            icono="mdi-arrow-up-bold"
            position="absolute"
            heigth="4%" width="4%" top="78%" left="23%"
            ></hmi-pulsador>
            <!--Estado grupo resistencias 1-->
            <hmi-estado
            heigth="4%" width="4%" top="82%" left="23%"
            :valor="estadoGrupoResistencias1"
            ></hmi-estado>

             <!-- resistencia 2 -->
        <hmi-pulsador
            @click="pulsadorResistencia2"
            icono="mdi-arrow-up-bold"
            position="absolute"
            heigth="4%" width="4%" top="78%" left="34.75%"
            ></hmi-pulsador>
             <!--Estado grupo resistencias 2-->
             <hmi-estado
             heigth="4%" width="4%" top="82%" left="34.75%"
            :valor="estadoGrupoResistencias2"
            ></hmi-estado>

            <!-- resistencia 3 -->
        <hmi-pulsador
            @click="pulsadorResistencia3"
            icono="mdi-arrow-up-bold"
            position="absolute"
            heigth="4%" width="4%" top="78%" left="50%"
            ></hmi-pulsador>
             <!--Estado grupo resistencias 3-->
            <hmi-estado
            heigth="4%" width="4%" top="82%" left="50%"
            :valor="estadoGrupoResistencias3"
            ></hmi-estado>

        <!-- VENTILADOR -->
        <hmi-pulsador
            @click="pulsadorVentilador"
            icono="mdi-arrow-up-bold"
            position="absolute"
            heigth="4%" width="4%" top="79%" left="82%"
            ></hmi-pulsador>
            <!-- Estado motor ventilador-->
            <hmi-estado
            heigth="4%" width="4%" top="88%" left="82%"
            :valor="estadoMotorVentilador"
            ></hmi-estado>
    </div>
</template>
<script>
    // import HmiComponente from '@/components/HMI/modulos/HmiComponente.vue'
     import HmiComponenteAutoMan from '@/components/HMI/modulos/HmiComponenteAutoMan.vue'
     import HmiComponenteEstadoBarrera from '@/components/HMI/modulos/HmiComponenteEstadoBarrera.vue'
     import HmiComponenteDetectorTajadera from '@/components/HMI/modulos/HmiComponenteDetectorTajadera.vue'
     import HmiComponenteMostrarValor from '@/components/HMI/modulos/HmiComponenteMostrarValor.vue'
     import HmiPulsador from '@/components/HMI/modulos/HmiPulsador.vue'
     import HmiEstado from '@/components/HMI/modulos/HmiEstado.vue'
     import HmiEstadoBuleano from '@/components/HMI/modulos/HmiEstadoBuleano.vue'
    import HmiComponenteSelectorPrograma from "@/components/HMI/modulos/HmiComponenteSelectorPrograma.vue";

import { mapActions } from 'vuex'

export default {
    components:{
        HmiComponenteAutoMan,HmiComponenteEstadoBarrera,HmiComponenteDetectorTajadera,HmiComponenteMostrarValor,
        HmiPulsador,HmiEstado,HmiEstadoBuleano,HmiComponenteSelectorPrograma
    },

    props:{
        datos:{}
    },

    // watch:{
    //     selectorAutoMan(val){
    //         console.log("eeeeeeeeeeeeeeeeeeee")
    //         console.log(val)
    //         //this.cambioAutoman(val)
    //     }
    // },

    computed: {
        selectorAutoMan(){
            if('Selector_Auto-Man' in this.datos){
                return this.datos['Selector_Auto-Man']
            }
        },

        estadoBarrera(){
            if('Estado_Barreras_Seguridad' in this.datos){
                return this.datos['Estado_Barreras_Seguridad']
            }
        },

        detectorTajaderaArribaAbierta(){
            if('Detector tajadera_arriba_abierta' in this.datos){       
                return this.datos['Detector tajadera_arriba_abierta']
            }
           
        },
        detectorTajaderaArribaCerrada(){
            if('Detector tajadera_arriba_Cerrada' in this.datos){       
                return this.datos['Detector tajadera_arriba_Cerrada']
            }
        },
        detectorTajaderaAbajoAbierta(){
            if('Detector tajadera_arriba_abierta' in this.datos){       
                return this.datos['Detector tajadera_abajo_abierta']
            }
           
        },
        detectorTajaderaAbajoCerrada(){
            if('Detector tajadera_abajo_cerrada' in this.datos){       
                return this.datos['Detector tajadera_abajo_cerrada']
            }
        },
        //salidas
        temperaturaSalidaResistencias(){
            if('Out_AI_Temp_Salida_Resistencias' in this.datos){       
                return this.datos['Out_AI_Temp_Salida_Resistencias']
            } 
        }, temperaturaTromel(){
            if('Out_AI_Temp_Tromel' in this.datos){       
                return this.datos['Out_AI_Temp_Tromel']
            } 
        }, CaudalAire(){
            if('Out_AI_Caudal_Aire' in this.datos){       
                return this.datos['Out_AI_Caudal_Aire']
            } 
        },

        //EVS
        EvTajaderaArriba(){
            if('Estado_EV_Tajadera_arriba' in this.datos){       
                return this.datos['Estado_EV_Tajadera_arriba']
            } 
        },
        EvTajaderaAbajo(){
            if('Estado_EV_Tajadera_Abajo' in this.datos){       
                return this.datos['Estado_EV_Tajadera_Abajo']
            } 
        },

        marchaVariadorTromel(){
            if('Marcha_variador_tromel' in this.datos){       
                return this.datos['Marcha_variador_tromel']
            } 
        },
        estadoMotorTromel(){
            if('Estado_Motor_Tromel' in this.datos){       
                return this.datos['Estado_Motor_Tromel']
            } 
        },
        estadoTemperaturaResistencias(){
            if('Estado_Temp_Resistencias_Salida' in this.datos){       
                return this.datos['Estado_Temp_Resistencias_Salida']
            } 
        },
        ////// estados de grupos de resistencia//////
        estadoGrupoResistencias1(){
            if('Estado_grupo_resistencias_1' in this.datos){       
                return this.datos['Estado_grupo_resistencias_1']
            } 
        },
        estadoGrupoResistencias2(){
            if('Estado_grupo_resistencias_2' in this.datos){       
                return this.datos['Estado_grupo_resistencias_2']
            } 
        },
        estadoGrupoResistencias3(){
            if('Estado_grupo_resistencias_3' in this.datos){       
                return this.datos['Estado_grupo_resistencias_3']
            } 
        },
        estadoCalidadAire(){
            if('Estado_Q_Aire' in this.datos){       
                return this.datos['Estado_Q_Aire']
            } 
        },
        estadoMotorVentilador(){
            if('Estado_Motor_ventilador' in this.datos){       
                return this.datos['Estado_Motor_ventilador']
            } 
        },
        estadoDetectorPosicionado(){
            if('Estado_Detector_Posicionado' in this.datos){       
                return this.datos['Estado_Detector_Posicionado']
            } 
        },
        selectorPrograma(){
            if('Estado_Programa' in this.datos){
                return this.datos['Estado_Programa'];
            }
        }
        //
        //
    },//fin de las computadas

    methods: {
        ...mapActions('nodered',['doPublish']),
        tajaderaArriba(valor){
            let publication={
              topic:'PULSADOR_TAJADERA_ARRIBA',
              qos:2,
              payload:JSON.stringify({'valor':valor}) ,
            }
            this.doPublish(publication)
            
        },
        tajaderaAbajo(valor){
            let publication={
              topic:'PULSADOR_TAJADERA_ABAJO',
              qos:2,
              payload:JSON.stringify({'valor':valor}) ,
            }
            this.doPublish(publication)
            
        },
        pulsadorTromel(valor){
            let publication={
              topic:'PULSADOR_TROMEL',
              qos:2,
              payload:JSON.stringify({'valor':valor}) ,
            }
            this.doPublish(publication)
        },
        pulsadorResistencia1(valor){
            let publication={
              topic:'PULSADOR_RESISTENCIA_1',
              qos:2,
              payload:JSON.stringify({'valor':valor}) ,
            }
            this.doPublish(publication)
        },
        pulsadorResistencia2(valor){
            let publication={
              topic:'PULSADOR_RESISTENCIA_2',
              qos:2,
              payload:JSON.stringify({'valor':valor}) ,
            }
            this.doPublish(publication)
        },pulsadorResistencia3(valor){
            let publication={
              topic:'PULSADOR_RESISTENCIA_3',
              qos:2,
              payload:JSON.stringify({'valor':valor}) ,
            }
            this.doPublish(publication)
        },pulsadorVentilador(valor){
            let publication={
              topic:'PULSADOR_VENTILADOR',
              qos:2,
              payload:JSON.stringify({'valor':valor}) ,
            }
            this.doPublish(publication)
        },cambioAutoman(valor){
            let publication={
              topic:'SELECTOR_AUTO_MAN',
              qos:2,
              payload:JSON.stringify({'valor':valor}) ,
            }
            this.doPublish(publication)
        },cambioPrograma(valor){
            let publication={
              topic:'SELECTOR_PROGRAMA',
              qos:2,
              payload:JSON.stringify({'valor':valor}) ,
            }
            this.doPublish(publication)
        },
       
    },//fin de los métodos

  
    
}
</script>
<style>
    .componente{
        z-index: 20;
        background-color: lightblue;
       
  
        /* background-color: blue; */
    }
     .fondo{
        position: absolute;
        height: 90%;
        width: 100%;
        /*width: 100%;*/
        /*object-fit: cover;*/
        top: 10%;
        left: 0px;
    } 
    
</style>